<template>
  <generic-modal :title="$t('order')" ref="generic_modal">
    <div class="title is-4">
      {{ meta.customer_name }}
      <small> | {{ format_date(meta.create_date) }}</small>
    </div>
    <div class="subtitle">
      <span>{{ meta.customer_phone }} | {{ meta.customer_email }} </span>
    </div>
    <div class="title is-4 mt-6">{{ $t("order") }}</div>
    <div class="content">
      <ul>
        <li v-for="(product, pidx) in meta.bakery_order_items" :key="pidx">
          <span>{{ Number(product.quantity) }}</span> x
          <span>{{ product.product.name }}</span>
          <span v-if="product.customization">
            ({{ product.customization }})</span
          >
          <span class="is-pulled-right">{{
            format_currency(Number(product.quantity) * Number(product.price))
          }}</span>
        </li>
      </ul>
    </div>
    <div class="title is-4 is-pulled-right">
      {{ $t("total") }} {{ format_currency(meta.total) }}
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  get,
  post,
  generate_error_message_text,
  format_date,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "OrderModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.name || !v.meta.username || !v.meta.password;
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(order) {
      let v = this;
      v.set_initial_state();
      get("/bakery_order", { uuid: order.uuid })
        .then((res) => {
          v.meta = res;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        });

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      v.$emit("success", profile);
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        name: "",
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
